import { Plus, Link2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { WebhookRow } from './WebhookRow';
import { useFetchWebhooks } from '@/hooksApi';
import { SettingsBreadcrumb } from '@/components/SettingsBreadcrumb';
import { SettingsListLoading } from '@/components/SettingsListLoading';
import { ROUTE } from '@/config';

const SettingsWebhooks = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: webhooksData, isLoading: isLoadingWebhooks } = useFetchWebhooks();

  const webhooks = webhooksData?.object?.items || [];

  const handleCreateWebhook = () => {
    navigate(ROUTE.SETTINGS_WEBHOOKS_CREATE);
  };

  const handleEditWebhook = (webhook: any) => {
    navigate(ROUTE.SETTINGS_WEBHOOKS_EDIT.replace(':id', webhook.uid));
  };

  return (
    <div className='sd-scope sd-font flex flex-col'>
      <div className='p-6 space-y-6 max-w-3xl w-full mx-auto'>
        <SettingsBreadcrumb moduleName='web_hooks' moduleRoute={ROUTE.SETTINGS_WEBHOOKS} />

        <div className='flex items-center justify-between'>
          <h1 className='text-xl font-semibold text-sd-foreground'>{t('web_hooks')}</h1>
          <button
            onClick={handleCreateWebhook}
            className='flex items-center gap-2 px-4 py-2.5 rounded-lg bg-sd-primary text-sd-primary-foreground text-sm font-semibold hover:opacity-90 transition-opacity'
          >
            <Plus className='h-4 w-4' />
            {t('new_webhook')}
          </button>
        </div>

        {/* Webhook List */}
        {isLoadingWebhooks ? (
          <SettingsListLoading />
        ) : webhooks.length === 0 ? (
          <div className='rounded-2xl border border-sd-border bg-sd-card shadow-sm p-8 text-center'>
            <Link2 className='h-10 w-10 mx-auto text-sd-muted-foreground mb-3' />
            <p className='text-sm text-sd-muted-foreground'>{t('no_webhooks_yet')}</p>
          </div>
        ) : (
          <div className='space-y-3'>
            {webhooks.map((webhook) => (
              <WebhookRow key={webhook.uid} webhook={webhook} onEdit={handleEditWebhook} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SettingsWebhooks;
